import React from 'react';

import { formatPrice } from '~/util/format';
import QuotaPercentageContainer from '../MainPanelCards/QuotaPercentageContainer';
import PanelBodyText from '../MainPanelCards/PanelBodyText';

import * as Style from './styles';

function ChallengeProgress({ quotaLabel, currentQuotaValue, salesPercentage }) {
    const percentageValue = Number(salesPercentage) || 0;
    const barFill = Math.min(100, (percentageValue / 120) * 100);
    const quotaBatida = percentageValue >= 100;

    return (
        <Style.MainPanelComponentContainer primary>
            <Style.InnerMainPanelComponent>
                <PanelBodyText
                    text={quotaLabel}
                    value={formatPrice(currentQuotaValue)}
                />
                <Style.StyledLinearProgress
                    variant="determinate"
                    value={barFill}
                    quota={quotaBatida}
                />
            </Style.InnerMainPanelComponent>
            <QuotaPercentageContainer value={`${percentageValue}%`} />
        </Style.MainPanelComponentContainer>
    );
}

export default ChallengeProgress;
